export const hasRouteAccess = ({ user, allowedRoles, requiredPermissions }) => {
  if (!user) return false;

  const normalizeRole = (role) => String(role).toUpperCase().replace(/^ROLE_/, "");
  const hasRole = !allowedRoles || Boolean(user.roles?.some((role) => allowedRoles.map(normalizeRole).includes(normalizeRole(role))));
  const permissions = user.permission || [];
  const hasPermission = !requiredPermissions || (
    Array.isArray(requiredPermissions)
      ? requiredPermissions.some((permission) => permissions.includes(permission))
      : permissions.includes(requiredPermissions)
  );

  return hasRole && hasPermission;
};
